import api from '@/utils/api';

/**
 * Update company option
 * @param {string} companyId - Company Id
 * @returns {Promise}
 */
const getCompanyOptionsApi = (companyId) => (query) => {
  const queryString = query ? `?${query}` : '';
  return api.get(`company/${companyId}/option${queryString}`);
};

export default getCompanyOptionsApi;
